import { render } from "./ProjectProcure.vue?vue&type=template&id=23c2211f&scoped=true&ts=true"
import script from "./ProjectProcure.ts?vue&type=script&lang=ts"
export * from "./ProjectProcure.ts?vue&type=script&lang=ts"

import "./ProjectProcure.scss?vue&type=style&index=0&id=23c2211f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c2211f"]])

export default __exports__